<template>
  <v-row align-center justify-center :class="{ fullSize: loading }" class="mx-0">
    <v-col class="pa-0 generalClass-table-padding">
      <loading-page v-if="loading"></loading-page>

      <default-page
          v-else-if="error || !servers.length"
          imageUrl="/img/dynamic-src-images/servers.svg"
          title="Servers"
          text="It seems that you don't have any servers|Click Get Started below to add a server"
          :errorMessage="error ? errorMessage.message : ''"
          :buttonText="error ? 'Reload' : 'Get Started'"
          @button-clicked="buttonClicked"
      ></default-page>

      <div v-else ref="scroll-check-cont">
        <confirm-dialog
            :dialog="confirmDialog"
            @confirmation-event="deleteServer($event)"
            @mutate-confirm-dialog="mutateConfirmDialog"
            :text="itemDeletionText"
            :acceptButton="'Delete'"
        ></confirm-dialog>
        <v-row no-gutters>
          <v-col cols="12">
            <v-data-table
                :mobile-breakpoint="0"
                :height="
                `${
                  $vuetify.breakpoint.mdAndUp
                    ? windowSizeY - 100
                    : windowSizeY - 96
                }px`
              "
                :items-per-page="itemsPerPage"
                :page.sync="page"
                :custom-sort="currentSortingAlgo"
                fixed-header
                dense
                hide-default-header
                hide-default-footer
                :headers="headers"
                sort-by="id"
                :items="servers"
                single-expand
                :expanded.sync="expanded"
                class="main_page_table"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                <tr>
                  <th
                      v-for="header in headers.filter((el, index) => {
                        return index + 1 <= headersCounter;
                      })"
                      :key="header.value"
                      class="allTableHeaders"
                  >
                    <v-row>
                      <v-col height="100%">
                        <v-row
                            :class="header.value === 'action' ? 'pl-0' : 'pl-3'"
                            :style="
                              header.value === 'action' || headersCounter === 1
                                ? 'justify-content: center;'
                                : ''
                            "
                        >
                          <v-hover v-slot:default="{ hover }">
                            <p
                                :class="
                                  header.value === 'action'
                                    ? 'text-center'
                                    : 'allTableHeadersHover'
                                "
                                class="my-0 fullHeight"
                                @click="
                                  currentSortingAlgo = getNewSortingAlgo(
                                    header
                                  );
                                  selectedHeader = header.value;
                                "
                            >
                              {{ header.text }}
                              <v-icon
                                  v-show="header.value !== 'action'"
                                  :style="
                                    !hover && (selectedHeader !== header.value)
                                      ? 'opacity: 0.2;'
                                      : 'opacity: 1;'
                                  "
                                  style="font-size: 12px;margin-left: -3px;"
                              >
                                {{
                                  getSortingIcon(header.currentSortAlg)
                                }}
                              </v-icon>
                            </p>
                          </v-hover>
                        </v-row>
                      </v-col>
                    </v-row>
                  </th>
                </tr>
                </thead>
              </template>
              <template v-slot:item="{ item,index }">
                <tr
                    @click="expandRow(item)"
                    :id="
                    $vuetify.theme.dark
                      ? 'dataTableRow_dark'
                      : 'dataTableRow_light'
                  "
                    class="table_Row rowClick"
                >
                  <td
                      v-for="(header, index) in headersCounter !== headers.length
                      ? headersCounter
                      : headersCounter - 1"
                      :key="index"
                  >
                    <v-row>
                      <p v-if="headersCounter === 1" :style="`margin-left: 30% !important;`"></p>
                      <v-icon
                          v-if="
                          headers[index].value === 'name' &&
                            headersCounter !== headers.length
                        "
                          :class="
                          expanded.some((el) => el.id === item.id)
                            ? 'red--text pr-1 ml-3'
                            : 'primary--text pr-1 ml-3'
                        "
                          style="font-size: 16px;"
                      >
                        {{
                          expanded.some((el) => el.id === item.id)
                              ? "fas fa-times-circle"
                              : "fas fa-chevron-circle-down"
                        }}
                      </v-icon>
                      <p
                          class="char-lim"
                          :class="
                          headersCounter < headers.length &&
                          headers[index].value === 'name'
                            ? 'ml-1'
                            : 'ml-3'
                        "
                      >{{ item[headers[index].value] }}</p>
                    </v-row>
                  </td>
                  <td v-if="headersCounter === headers.length" class="text-center">
                    <v-btn icon @click="showEditServerDialog(item)">
                      <span style="font-size: 28px;" class="icon-edit-21x21">
                        <span class="path1 letterSpacing0"></span>
                        <span class="path2"></span>
                      </span>
                    </v-btn>

                    <v-btn :id="`delete-server${index}`" icon @click="confirmationDialog(item)">
                      <span style="font-size: 28px;" class="icon-delete-21x21">
                        <span class="path1 letterSpacing0"></span>
                        <span class="path2"></span>
                      </span>
                    </v-btn>
                    <v-tooltip :activator="`#delete-server${index}`" class="mt-3 ml-1" bottom>
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-slot:expanded-item="{ item }">
                <tr
                    v-for="(headerIndex, index) in headers.length -
                    headersCounter"
                    :key="index"
                    class="expandBackground"
                >
                  <v-row
                      style="height: 32px;"
                      class="expandRowClass_Border mx-0"
                      justify="space-around"
                  >
                    <v-col v-if="$vuetify.breakpoint.width < 411" cols="1"></v-col>
                    <v-col class="py-0" cols="3">
                      <p
                          class="ml-1 my-1"
                          style="font-weight: 600; font-size: 14px;"
                      >{{ headers[index + headersCounter].text }}</p>
                    </v-col>
                    <v-col class="py-0" cols="8">
                      <p
                          v-if="headerIndex < headers.length - headersCounter"
                          class="ml-1 my-1 pt-1 text-center char-lim"
                          style="font-size: 14px; margin:auto !important;"
                      >{{ item[headers[index + headersCounter].value] }}</p>
                      <div v-else class="text-center">
                        <v-tooltip class="mt-3 ml-1" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                                height="32"
                                icon
                                @click="showEditServerDialog(item)"
                                v-on="on"
                            >
                              <span
                                  style="font-size: 28px;color: grey !important;"
                                  class="icon-edit-21x21"
                              >
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip class="mt-3" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn height="32" icon @click="confirmationDialog(item)" v-on="on">
                              <span style="font-size: 28px;" class="icon-delete-21x21">
                                <span class="path1 letterSpacing0"></span>
                                <span class="path2"></span>
                              </span>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                  <td v-for="header in headersCounter - 1" :key="header" style="border: none;"></td>
                </tr>
              </template>
              <template v-slot:no-data>
                <v-text color="error" icon="warning">Sorry, nothing to display here :(</v-text>
              </template>
            </v-data-table>
            <div class="text-center custom-table-footer">
              <v-row
                  justify="space-between"
                  justify-sm="end"
                  class="mx-0"
              >
                <div
                    class="ml-2 pagination-item-1"
                >
                  <div
                      v-if="$vuetify.breakpoint.smAndUp"
                      class="mr-6"
                  >
                    Rows per page:
                  </div>
                  <div
                      :class="{ 'mr-1': $vuetify.breakpoint.smAndUp }"
                      class="footer-items-wrapper"
                  >
                    <v-select
                        dense
                        class="footer-items-per-page mt-0"
                        hide-details
                        :menu-props="{ top: true, offsetY: true }"
                        :items="[10, 25, 50, 100]"
                        v-model="itemsPerPage"
                        @change="paginationChangeHandler(1)"
                    >
                      <template v-slot:item="{ item }">
                        <div class="mb-0 char-lim-tabs page-rows-selection">
                          <div v-if="item === -1">All</div>
                          <div v-else>{{ item }}</div>
                        </div>
                      </template>
                      <template v-slot:selection="{ item }">
                        <div class="page-rows-selection">
                          <div v-if="item === -1">
                            All
                          </div>
                          <div v-else>
                            {{ item }}
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <v-pagination
                    v-model="page"
                    @input="paginationChangeHandler"
                    :length="totalPages"
                    :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7"
                    circle
                    class="pagination"
                ></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-btn
          v-if="(servers.length) && (isAdmin === true)"
          fab
          bottom
          right
          :style="{ bottom: '70px' }"
          :color="$vuetify.theme.dark ? '#685AA1' : 'primary'"
          dark
          fixed
          @click="showAddServerDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog
          transition="scroll-x-transition"
          overlay-color="grey darken-2"
          v-model="dialog"
          :width="$vuetify.breakpoint.smAndUp ? '550px' : '350px'"
          persistent
      >
        <v-card color="accent">
          <v-card-title style="background-color:#47BD96;color:white">
            {{ editing ? 'Edit Server' : 'Add Server' }}
          </v-card-title>
          <v-container
              grid-list-sm
              class="pa-4 pb-0 pt-5 mt-2"
              :style="
              $vuetify.breakpoint.smAndUp ? 'width:550px' : 'width: 310px'
            "
          >
            <v-form :lazy-validation="false" ref="form" v-model="valid">
              <v-layout row wrap>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                      dense
                      outlined
                      :autofocus="true"
                      v-model="server.login"
                      label="Login"
                      :rules="[rules.required, rules.integer]"
                      autocomplete="username"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                      class="textFieldOverride small-icon"
                      dense
                      outlined
                      autocomplete="new-password"
                      counter
                      :append-icon="showPassword
                        ? 'fas fa-eye'
                        : 'fas fa-eye-slash'
                  "
                      :hint="passwordHint"
                      :persistent-hint="editing"
                      label="Password"
                      @click:append="showPassword = !showPassword"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="server.password"
                      :rules="editing ? [] : [rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-text-field
                      dense
                      outlined
                      label="Server Name"
                      v-model="server.name"
                      :rules="[rules.required, rules.maxCharName]"
                      counter
                      hint="Max 50 Characters"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                      dense
                      outlined
                      label="Server Address e.g. 183.78.19.1"
                      v-model="server.server"
                      :rules="[rules.required, rules.serverAddress]"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" sm="2">
                  <v-text-field v-model="server.port" dense outlined placeholder="443"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" sm="4">
                  <v-select
                      dense
                      outlined
                      :items="serverVersionOptions"
                      :menu-props="{ offsetY: true, maxHeight: '250' }"
                      label="Select"
                      hide-details
                      single-line
                      v-model="server.version"
                  ></v-select>
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-text-field
                      label="Description"
                      dense
                      outlined
                      v-model="server.description"
                      :rules="[rules.maxCharDescription]"
                      counter
                      hint="Max 200 Characters"
                  ></v-text-field>
                </v-col>
              </v-layout>
            </v-form>
          </v-container>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn text @click="cancelHandler">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.form.validate() ? saveHandler() : false">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import {ServerService} from "@/services/ApiService";
import {
  LoadingPage,
  DefaultPage,
  ConfirmDialog,
} from "../components/Default-Page-Components";
import {mapGetters} from "vuex";

export default {
  name: "Servers",
  components: {ConfirmDialog, LoadingPage, DefaultPage},
  data() {
    return {
      editing: false,
      page: 1,
      totalPages: 0,
      itemsPerPage: 25,
      itemToDelete: {},
      confirmDialog: false,
      selectedHeader: "",
      COLUMN_SORTS: {
        NUMBERS: {DESC: 0, ASC: 1},
        STRINGS: {DESC: 2, ASC: 3},
        IPS: {DESC: 4, ASC: 5},
      },
      currentSortingAlgo: (items) => items,
      expanded: [],
      servers: [],
      server: {
        description: "",
        id: null,
        login: null,
        name: "",
        password: "",
        port: "",
        server: "",
        version: "",
      },
      serverVersionOptions: [],
      showPassword: false,
      dialog: false,
      loading: false,
      error: null,
      errorMessage: "",
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
          type: "String",
          currentSortAlg: null,
        },
        {text: "Login", value: "login", type: "Number", currentSortAlg: null},
        {
          text: "Address",
          value: "server",
          type: "IP",
          currentSortAlg: null,
        },
        {
          text: "Version",
          value: "version",
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Description",
          value: "description",
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          currentSortAlg: null,
        },
      ],
      valid: true,
      rules: {
        required: (value) => !!value || "Required",
        min: (value) =>
            (value != null && value.length > 7) || "Min 8 characters",
        serverAddress: (value) => {
          const pattern = /^((\*)|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|((\*\.)?([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,63}?))$/;
          return pattern.test(value) || "Invalid server address";
        },
        integer: (value) => {
          const pattern = /^-?[0-9]+$/;
          return pattern.test(value) || "Login must be a number";
        },
        maxCharDescription: (val) => {
          return !val || val.length < 201;
        },
        maxCharName: (val) => {
          return !val || val.length < 51;
        },
      },
      dialogCount: 0,
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    passwordHint() {
      if (this.editing && (!this.server.password || typeof this.server.password === 'string' && (this.server.password.length < 1))) {
        return "Fill to change password"
      } else return typeof this.server.password == 'string' && this.server.password.length < 9 ? 'Weak password' : ''
    },
    itemDeletionText() {
      return Object.keys(this.itemToDelete).length
          ? `Delete server ${this.itemToDelete.name} ?`
          : "";
    },
    headersCounter() {
      switch (true) {
        case this.$vuetify.breakpoint.width < 411:
          return 1;
        case this.$vuetify.breakpoint.width < 456:
          return 2;
        case this.$vuetify.breakpoint.width < 670:
          return 3;
        case this.$vuetify.breakpoint.width < 800:
          return 4;
        default:
          return this.headers.length;
      }
    },
  },
  props: {
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 1200,
    },
  },
  created() {
    if (window.innerWidth > 320 && !this.isNotDesktop) {
      document.getElementById("htmlId").style.overflowY = "hidden";
    }
    this.fetchServers();
    this.getServerVersions();
  },
  methods: {
    /**
     * Get all the available server versions and map them
     * to the version selection input options
     * @returns {Promise<void>}
     */
    async getServerVersions() {
      this.loading = true;
      try {
        const serverVersionsResponse = await ServerService.get('versions');
        // console.log('serverVersionsResponse.data');
        // console.log(serverVersionsResponse.data);
        this.serverVersionOptions = serverVersionsResponse.data.map((versionItem) => {
          return {text: versionItem};
        });
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    editServer() {
      let id = this.server.id
      let params = JSON.parse(JSON.stringify(this.server))
      if (!params.password || typeof params.password == "string" && !params.password.length) {
        delete params.password
      }

      // Remove unnecessary fields
      delete params.id
      delete params.index

      ServerService.put(id, params)
          .then(() => {
            this.$notifier.info(`Server saved`);
            this.refreshServers();
          })
          .catch(error => {
            console.error(error);
            this.$notifier.error("Couldn't save server", {error: error});
          })
    },
    saveHandler() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.editing) this.editServer()
      else this.createServer()
    },
    /**
     * Close the server editor dialog and reset the local data to its default value
     */
    cancelHandler() {
      this.dialog = false;
      this.resetLocalServerData();
    },
    paginationChangeHandler(page) {
      this.page = page;
      this.fetchServers();
    },
    /**
     * Reset the local server data to its initial value
     */
    resetLocalServerData() {
      this.server = {
        description: "",
        id: null,
        login: null,
        name: "",
        password: "",
        port: "",
        server: "",
        version: "",
      };
    },
    getDefinitionsQueryParams() {
      return {
        size: this.itemsPerPage,
        page: this.page - 1,
      }
    },
    executeShortCuts() {
      if (
          this.$route.query &&
          this.$route.query.add &&
          !this.loading &&
          !this.error
      ) {
        setTimeout(() => {
          this.dialog = true;
        }, 100);
      }
    },
    buttonClicked() {
      if (this.error) this.reloadThisPage();
      else this.showAddServerDialog();
    },
    mutateConfirmDialog(value) {
      this.confirmDialog = value;
    },
    confirmationDialog(item) {
      this.itemToDelete = item;
      this.confirmDialog = !this.confirmDialog;
    },
    getSortingIcon(algo) {
      switch (algo) {
        case this.COLUMN_SORTS.NUMBERS.ASC:
        case this.COLUMN_SORTS.STRINGS.ASC:
        case this.COLUMN_SORTS.IPS.ASC:
          return "fas fa-arrow-down";
        default:
          return "fas fa-arrow-up";
      }
    },
    clearAllHeadersSorting(header) {
      this.headers.map((el) => {
        if (el.text !== header.text && el.currentSortAlg != null) {
          el.currentSortAlg = null;
          return el;
        } else {
          return el;
        }
      });
    },
    getNewSortingAlgo(header) {
      if (header.text !== this.selectedSort) {
        this.selectedSort = this.headers.find(
            (el) => el.value === header.value
        ).text;
      }
      switch (header.type) {
        case "Number":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.NUMBERS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.NUMBERS.ASC;
            if (header.value === "server") {
            }
            this.clearAllHeadersSorting(header);
            return this.numSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.NUMBERS.DESC;
            this.clearAllHeadersSorting(header);
            return this.numSortDesc;
          }
        case "String":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.STRINGS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.STRINGS.ASC;
            this.clearAllHeadersSorting(header);
            return this.stringSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.STRINGS.DESC;
            this.clearAllHeadersSorting(header);
            return this.stringSortDesc;
          }
        case "IP":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.IPS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.IPS.ASC;
            this.clearAllHeadersSorting(header);
            return this.ipSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.IPS.DESC;
            this.clearAllHeadersSorting(header);
            return this.ipSortDesc;
          }
        default:
          return;
      }
    },
    numSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.NUMBERS.ASC);
    },
    numSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.NUMBERS.DESC);
    },
    ipSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.IPS.ASC);
    },
    ipSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.IPS.DESC);
    },
    stringSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.ASC);
    },
    stringSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.DESC);
    },
    secondarySort(items, typeAndOrder) {
      switch (typeAndOrder) {
        case this.COLUMN_SORTS.NUMBERS.ASC:
          return items.sort(
              (a, b) => a[this.selectedHeader] - b[this.selectedHeader]
          );
        case this.COLUMN_SORTS.NUMBERS.DESC:
          return items.sort(
              (a, b) => b[this.selectedHeader] - a[this.selectedHeader]
          );
        case this.COLUMN_SORTS.STRINGS.ASC:
          return items.sort((a, b) =>
              a[this.selectedHeader] > b[this.selectedHeader]
                  ? 1
                  : b[this.selectedHeader] > a[this.selectedHeader]
                      ? -1
                      : 0
          );
        case this.COLUMN_SORTS.STRINGS.DESC:
          return items.sort((a, b) =>
              b[this.selectedHeader] > a[this.selectedHeader]
                  ? 1
                  : a[this.selectedHeader] > b[this.selectedHeader]
                      ? -1
                      : 0
          );
        case this.COLUMN_SORTS.IPS.ASC:
          return items.sort((a, b) => {
            let parent = this;
            const num1 = Number(
                a[parent.selectedHeader]
                    .split(".")
                    .map((num) => `000${num}`.slice(-3))
                    .join("")
            );
            const num2 = Number(
                b[parent.selectedHeader]
                    .split(".")
                    .map((num) => `000${num}`.slice(-3))
                    .join("")
            );
            return num1 - num2;
          });
        case this.COLUMN_SORTS.IPS.DESC:
          return items.sort((a, b) => {
            const num1 = Number(
                a[this.selectedHeader]
                    .split(".")
                    .map((num) => `000${num}`.slice(-3))
                    .join("")
            );
            const num2 = Number(
                b[this.selectedHeader]
                    .split(".")
                    .map((num) => `000${num}`.slice(-3))
                    .join("")
            );
            return num2 - num1;
          });
        default:
          return;
      }
    },
    expandRow(item) {
      if (this.expanded.length) {
        if (this.expanded[0].id === item.id) {
          this.expanded.pop();
        } else {
          this.expanded.pop();
          this.expanded.push(item);
        }
      } else {
        this.expanded.push(item);
      }
    },
    reloadThisPage() {
      this.fetchServers();
    },
    showAddServerDialog() {
      if (this.isAdmin === true) {
        this.editing = false
        this.dialog = !this.dialog;
        if (this.dialogCount === 0) {
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
            this.dialogCount++;
          });
        }
        if (this.dialog) {
          this.server.port = 443;
          this.server.version = "MT5";
        }
      }
    },
    fetchServers() {
      this.error = null;
      this.loading = true;
      let params = this.getDefinitionsQueryParams();
      ServerService.query({params: params})
          .then((response) => {
            if (response.data.content) {
              this.servers = response.data.content.map((el, index) => {
                // this.servers = response.data.map((el, index) => {
                el.index = index;
                return el;
              });
              this.totalPages = response.data.totalPages;
            }
          })
          .catch((error) => {
            this.errorMessage = error;
            this.error = true;
          })
          .finally(() => {
            this.loading = false;
            this.executeShortCuts();
          });
    },
    async createServer() {
      try {
        await ServerService.post(this.server);
        this.$notifier.info(`Server ${this.server.name} is created!`);
        this.refreshServers();
      } catch (error) {
        console.error(error);
        this.$notifier.error(
            `Server ${this.server.name} could not be created.`, {error: error}
        );
      }
      this.dialog = false;
    },
    async refreshServers(extraParams = null) {
      let params = this.getDefinitionsQueryParams();
      if (extraParams != null)
        params = Object.assign(params, extraParams);

      ServerService.query({params: params})
          .then(response => {
            if (response.data.content) {
              this.servers = response.data.content.map((el, index) => {
                el.index = index;
                return el;
              });
              this.totalPages = response.data.totalPages;
            }
            this.dialog = false;
          })
          .catch(error => {
            console.error(error);
            this.$notifier.error(`Couldn't save server`);
            this.dialog = false;
          })
    },
    async deleteServer(confirmDeletion) {
      if (confirmDeletion) {
        try {
          await ServerService.delete(this.itemToDelete.id);
          this.$notifier.info(`Server ${this.itemToDelete.name} is deleted!`);

          if (this.servers.length === 1) {
            let pageToFetch = this.page - 1
            if (this.page > 1) {
              this.page--
              pageToFetch--
            }
            this.refreshServers({page: pageToFetch});
          } else
            this.refreshServers();

        } catch (error) {
          this.$notifier.error(
              `Could not delete server ${this.itemToDelete.name}.`, {error: error}
          );
        }
      }
      this.confirmDialog = !this.confirmDialog;
    },
    showEditServerDialog(server) {
      this.editing = true
      this.dialog = true;
      // if (this.dialogCount == 0) {
      this.$nextTick(() => {
        this.$refs.form.resetValidation();
        // this.dialogCount++;
      });
      // }
      this.server = JSON.parse(JSON.stringify(server))
      this.server.password = null
    },
  },
  watch: {
    dialog(value) {
      value
          ? ""
          : this.$nextTick(() => {
            this.$refs.form.reset();
          });
    },
  },
};
</script>
<style scoped src="../css/utilities/scoped/servers.css"></style>
